<template>
  <div>
    <v-card class="defaultCardSharedClass mt-6" flat>
      <!-- User Information -->
      <v-card-title>
        <v-layout align-center row wrap style="position: relative">
          <feed-post-header :itemData="itemData" />
          <v-spacer />
        </v-layout>
      </v-card-title>

      <!-- Content Detail -->
      <v-layout fill-height row wrap mx-4 mb-3>
        <v-flex xs12>
          <!-- Title -->
          <v-layout
            row
            wrap
            class="overflow-x-hidden pr-3 mt-0"
            style="line-height: 20px; word-wrap: break-word"
          >
            <h4
              style="font-size: 15px; overflow-y: hidden"
              @click="$router.push(`/feed/${itemData.feedId}`)"
              :class="`hover-underline defaultColor--text font-weight-medium`"
              v-html="itemData.Content"
            ></h4>
          </v-layout>

          <!-- users -->
          <v-layout
            row
            wrap
            class="mt-2 pr-3 font-weight-bold"
            style="line-height: 18px; font-size: 15px"
          >
            <span
              :class="
                index !== 0
                  ? 'ml-3 defaultColorLight--text'
                  : 'defaultColorLight--text'
              "
              v-for="(User, index) in itemData.RelatedUsers"
              :key="index"
              >{{ User.FullName + '&nbsp;' }}</span
            >
          </v-layout>

          <!-- tags -->
          <v-layout
            v-if="itemData.Tags.length > 0"
            row
            wrap
            class="mt-2 pr-3 defaultColor--text font-weight-light"
            style="line-height: 17px; font-size: 16px"
          >
            <span
              :class="'mr-3'"
              v-for="(tag, index) in itemData.Tags"
              :key="index"
              >{{ '#' + tag.TagName }}</span
            >
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- Media -->
      <div>
        <div id="inspire" v-if="isCrousel">
          <v-carousel>
            <v-carousel-item
              v-for="(item, i) in itemData.Files"
              :key="i"
              :src="item.LocalUrl"
              contain
              @click="ImageDialog = true"
            ></v-carousel-item>
          </v-carousel>
        </div>

        <div
          v-if="isFiles"
          style="background-color: rgba(0, 0, 0, 0); padding: 30px"
        >
          <v-img
            style="cursor: pointer"
            @click="ImageDialog = true"
            class="align-end pa-4"
            :aspect-ratio="16 / 9"
            :src="itemData.Files[0].LocalUrl"
            contain
            v-if="!computedMedia"
          >
          </v-img>
          <video
            width="100%"
            style="
              object-fit: contain !important;
              max-height: 519px;
              background-color: black !important;
            "
            controls
            controlsList="nodownload"
            muted
            v-else
          >
            <source :src="computedMedia.LocalUrl" type="video/mp4" />
          </video>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import FeedPostHeader from './FeedPostHeader.vue';
export default {
  props: {
    itemData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      observer: null,
    };
  },

  components: {
    FeedPostHeader,
  },

  mounted() {
    this.initializeObserver();
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    initializeObserver() {
      const options = {
        root: null,
        threshold: 0.5,
      };

      this.observer = new IntersectionObserver(
        this.handleIntersection,
        options
      );

      const videos = this.$el.querySelectorAll('video');
      videos.forEach((video) => this.observer.observe(video));
    },
    handleIntersection(entries) {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // video.currentTime = 0;
          video.play().catch((err) => console.error('Autoplay error:', err));
        } else {
          video.pause();
        }
      });
    },
  },

  computed: {
    computedMedia() {
      return this.itemData.Files.find(
        (i) => i.FileExtension === '.mp4' || i.FileExtension === '.mov'
      );
    },

    isFiles() {
      if (this.itemData.Files.length == 1) {
        return true;
      } else {
        return false;
      }
    },

    isCrousel() {
      if (this.itemData.Files.length > 1) {
        return true;
      } else {
        return false;
      }
    },

    getLikerUnderine() {
      if (this.itemData.LikeCount !== 0) {
        return 'hover-underline';
      }
    },
  },
};
</script>

<style></style>
